import React from 'react';
import i18n from 'i18next';
import { CurrencyInputLabel, Form } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { InheritedInput } from '../../../pages/rates/rateForm';
import Styles from '../../../styles/rate/rateCreation.module.css';
import RateError from '../../../pages/rates/components/rateError';
import useAppContext from '../../../context/useAppContext';

export default function SellingPrice({ onDebouncePriceChange, formErrors, form, event, rateLimit, loadingSettings, rate, settings, includeTaxInPrice, totalBuyerMode = false }) {
    const { t } = useTranslation();
    const [{ organization }] = useAppContext();

    const label = React.useMemo(() => {
        if (totalBuyerMode) {
            return t(`ticket.rates.infos.total.total-buyer-selling-price${form.type === 'open' ? '-open' : ''}`);
        }
        return t(`ticket.rates.infos.total.selling-price${form.type === 'open' ? '-open' : ''}`);
    }, [t, totalBuyerMode, form]);

    const currency = React.useMemo(() => {
        return organization?.currency || 'EUR';
    }, [organization?.currency]);

    return (
        <div className={`${Styles['amount']} ${rate?.rate_template ? Styles['amount-template'] : ''} ${totalBuyerMode ? Styles['amount-buyer-mode'] : ''}`}>
            <span className={`${Styles['amount-label']} ${totalBuyerMode ? Styles['amount-label-buyer-mode'] : ''}`}>{label}</span>
            <div className={`${Styles['amount-commission-container']} ${settings?.values.aff_ht !== '1' ? Styles['amount-commission-container-without-taxes'] : ''}`}>
                <Form.Field className={Styles['infos-field-price']}>
                    <InheritedInput onChange={onDebouncePriceChange('base-price', 'with-tax')} formState={form} property="price" rate={rate} linkPosition="left">
                        <CurrencyInputLabel
                            {...(settings?.values.aff_ht === '1' && { label: t('ticket.rates.infos.priceMinShort') })}
                            errors={formErrors['price'] ? true : false}
                            disabled={form?.type === 'free'}
                            name="price"
                            locale={i18n.language}
                            currency={currency}
                            onChange={onDebouncePriceChange('base-price', 'with-tax')}
                        />
                    </InheritedInput>
                    <Form.FieldErrors errors={formErrors['price'] ? [t(formErrors['price'])] : null} />
                    {event && rateLimit && <RateError event={event} maxPrice={form.maxPrice} />}
                    {event && form.price < 1 && form.type !== 'free' && !form.rate_template_id && <RateError event={event} price={form.price} />}
                </Form.Field>
                {['fixed', 'open'].includes(form.type) && !loadingSettings && settings.values.aff_ht === '1' && (
                    <Form.Field className={Styles['infos-field-price']}>
                        <CurrencyInputLabel
                            label={t('ticket.rates.infos.priceNoTaxesShort')}
                            errors={formErrors['price'] ? true : false}
                            disabled={form?.type === 'free' || form.price === null}
                            name="price"
                            locale={i18n.language}
                            currency={currency}
                            onChange={onDebouncePriceChange('base-price', 'without-tax')}
                            value={includeTaxInPrice(false, form.price ? form.price : rate.rate_template?.price)}
                        />
                        <Form.FieldErrors errors={formErrors['price'] ? [t(formErrors['price'])] : null} />
                        {event && rateLimit && <RateError event={event} maxPrice={form.maxPrice} />}
                        {event && form.price < 1 && form.type !== 'free' && !form.rate_template_id && <RateError event={event} price={form.price} />}
                    </Form.Field>
                )}
            </div>
        </div>
    );
}
